module.exports = __webpack_public_path__ + "media/images/icon_list/icon_circle_sns_images-5bf68f280b98d0686839ec44f77bcf66.svg";